"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_Y_AXIS_OPTIONS = exports.DEFAULT_X_AXIS_OPTIONS = exports.DEFAULT_TOOLTIP_OPTIONS = exports.DEFAULT_BAR_OPTIONS = exports.DEFAULT_TITLE_OPTIONS = exports.DEFAULT_SUBTITLE_OPTIONS = exports.DEFAULT_FOOTER_OPTIONS = exports.DEFAULT_Y_TYPE = exports.DEFAULT_X_TYPE = exports.DEFAULT_WIDTH = exports.DEFAULT_TOOLTIP_SHOW_SUBTITLE = exports.DEFAULT_TOOLTIP_SHOW = exports.DEFAULT_TOOLTIP_POSITION = exports.DEFAULT_TOOLTIP_PADDING = exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_HEIGHT = exports.DEFAULT_FOOTER_SHOW_METRIC_FOOTNOTES = exports.DEFAULT_FOOTER_SHOW = exports.DEFAULT_CHART_Y_PADDING = exports.DEFAULT_CHART_X_PADDING = exports.DEFAULT_BAR_SPACING = exports.AXIS_POSITIONS = void 0;
const lodash_1 = __importDefault(require("lodash"));
const constants_1 = require("../../utilities/constants");
const ChartWrapper_1 = require("../../components/ChartWrapper");
const Axis_1 = require("../../components/Axis");
// types
exports.AXIS_POSITIONS = lodash_1.default.pick(Axis_1.AXIS_POSITIONS, [Axis_1.AXIS_POSITIONS.top, Axis_1.AXIS_POSITIONS.bottom, Axis_1.AXIS_POSITIONS.left, Axis_1.AXIS_POSITIONS.right]);
// Defaults
exports.DEFAULT_BAR_SPACING = 0;
exports.DEFAULT_CHART_X_PADDING = 5;
exports.DEFAULT_CHART_Y_PADDING = 0;
exports.DEFAULT_FOOTER_SHOW = true;
exports.DEFAULT_FOOTER_SHOW_METRIC_FOOTNOTES = true;
exports.DEFAULT_HEIGHT = 300;
exports.DEFAULT_TEXT_COLOR = '#4D4D4D';
exports.DEFAULT_TOOLTIP_PADDING = 10;
exports.DEFAULT_TOOLTIP_POSITION = 'above';
exports.DEFAULT_TOOLTIP_SHOW = true;
exports.DEFAULT_TOOLTIP_SHOW_SUBTITLE = true;
exports.DEFAULT_WIDTH = 'auto';
exports.DEFAULT_X_TYPE = 'years';
exports.DEFAULT_Y_TYPE = 'linear';
// Default Options (Chart Wrapper)
exports.DEFAULT_FOOTER_OPTIONS = {
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  footnotes: undefined,
  show: exports.DEFAULT_FOOTER_SHOW,
  showMetricFootnotes: exports.DEFAULT_FOOTER_SHOW_METRIC_FOOTNOTES,
  sources: undefined
};
exports.DEFAULT_SUBTITLE_OPTIONS = {
  fontSize: ChartWrapper_1.DEFAULT_SUBTITLE_FONT_SIZE,
  text: undefined
};
exports.DEFAULT_TITLE_OPTIONS = {
  fontSize: ChartWrapper_1.DEFAULT_TITLE_FONT_SIZE,
  text: undefined
};
// Default Options
exports.DEFAULT_BAR_OPTIONS = {
  color: undefined,
  spacing: exports.DEFAULT_BAR_SPACING,
  negativeColor: undefined
};
exports.DEFAULT_TOOLTIP_OPTIONS = {
  decimals: undefined,
  position: exports.DEFAULT_TOOLTIP_POSITION,
  show: exports.DEFAULT_TOOLTIP_SHOW,
  showSubtitle: exports.DEFAULT_TOOLTIP_SHOW_SUBTITLE
};
exports.DEFAULT_X_AXIS_OPTIONS = {
  displayRangeMin: undefined,
  displayRangeMax: undefined,
  displayTicks: ['bottom'],
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  showGridlines: undefined,
  textColor: exports.DEFAULT_TEXT_COLOR,
  ticks: undefined,
  type: undefined
};
exports.DEFAULT_Y_AXIS_OPTIONS = {
  decimals: undefined,
  displayRangeMin: undefined,
  displayRangeMax: undefined,
  displayTicks: ['left'],
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  showGridlines: undefined,
  textColor: exports.DEFAULT_TEXT_COLOR,
  ticks: undefined,
  type: undefined
};